import React from 'react';

import type { SVGProps } from 'react';

const CalendarIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="3.06245"
      y="0.34028"
      width="0.680561"
      height="1.41946"
      stroke="currentColor"
      strokeWidth="0.680561"
    />
    <rect
      x="8.50727"
      y="0.34028"
      width="0.680561"
      height="1.41946"
      stroke="currentColor"
      strokeWidth="0.680561"
    />
    <rect
      x="0.5"
      y="1.8999"
      width="11.2501"
      height="11.6001"
      stroke="currentColor"
    />
    <rect y="2.1001" width="12.2501" height="3.50003" fill="currentColor" />
    <rect
      x="2.38227"
      y="7.34028"
      width="0.680561"
      height="0.71945"
      stroke="currentColor"
      strokeWidth="0.680561"
    />
    <rect
      x="5.78462"
      y="7.34028"
      width="0.680561"
      height="0.71945"
      stroke="currentColor"
      strokeWidth="0.680561"
    />
    <rect
      x="9.18745"
      y="7.34028"
      width="0.680561"
      height="0.71945"
      stroke="currentColor"
      strokeWidth="0.680561"
    />
  </svg>
);

export default CalendarIcon;
